<div class="not-found">
  <h1>{{ 'not-found.error-text' |translate }}</h1>
  <h3>{{ 'not-found.subtext' |translate }}</h3>

  <a [routerLink]="['/dashboard']">{{ 'not-found.back-btn' |translate }}</a>
</div>
